// Skip to Content Link
// Provides keyboard navigation accessibility for screen readers

import React from 'react';
import './SkipToContent.css';

function SkipToContent() {
  const handleClick = (e) => {
    e.preventDefault();
    const mainContent = document.getElementById('hero-root') || document.querySelector('main') || document.querySelector('.App');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a 
      href="#hero-root" 
      className="skip-to-content"
      onClick={handleClick}
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
}

export default SkipToContent;

